import { Maestro_DashBoard } from './Maestro_DashBoard';
import { Maestro_Roles_DashBoard } from './Maestro_Roles_DashBoard';

export class Maestro_Dashboard_Actualizacion {
    principal: Maestro_DashBoard;
    listaRoles: Maestro_Roles_DashBoard[];
}
